import api from 'src/Utils/api';
export var useCleanBuildingData = function (buildingId) {
    return api.post("/buildings/" + buildingId + "/clean", {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};
